import { Box, IconButton, InputAdornment, TextField } from "@mui/material";
import {useState} from "react";
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';

interface SearchButtonProps{
    height?: number;
    searchValue?: string;
    setSearchValue?: (value: string) => void;
    handleOnSearchChange?: (value: string) => void;
}

const SearchButton = (props:SearchButtonProps) => {
    const {height, searchValue, setSearchValue, handleOnSearchChange} = props;
    const handleClear = (e) => {
        setSearchValue?.('');
        handleOnSearchChange?.("");
    }

    const iconSize = (height === 32) ? 24 : 18;

    const handleSearch = (e) => {
        handleOnSearchChange?.(e.target.value);
        setSearchValue?.(e.target.value)
    }

    return (
        <Box
            sx={{
                mr: 0,
                width: '244px',
            }}
        >
            <TextField
                  variant="outlined"
                  placeholder="Type something"
                  autoComplete="off"
                  autoFocus
                  value={searchValue}
                  onChange={(e) => handleSearch(e)}
                  className="searchbar-wrapper"
                  sx={{
                    width: 200,
                    height,
                    '& .MuiInputBase-root': {
                      height,
                      minHeight: height,
                      paddingRight: '8px',
                      boxSizing: 'border-box',
                      width: '244px'
                    },
                    '& .MuiOutlinedInput-notchedOutline': {
                      borderColor: '#ccc',
                    },
                    '& input': {
                      padding: '0 10px',
                      height: '100%',
                      fontFamily: 'Roboto',
                      fontSize: '14px',
                      letterSpacing: '0.2px',
                      boxSizing: 'border-box',
                    },
                }}
                InputProps={{
                    endAdornment: (
                    <InputAdornment position="end">
                        {searchValue ? (
                            <IconButton size="small" onClick={(e) => handleClear(e)} sx={{ padding: 0 }}>
                            <CloseIcon
                            sx={{
                                width: `${iconSize}px !important`,
                                height: `${iconSize}px !important`,
                            }}
                            />
                        </IconButton>
                        ) : (
                        <IconButton size="small" sx={{ padding: 0 }}>
                            <SearchIcon
                            sx={{
                                width: `${iconSize}px !important`,
                                height: `${iconSize}px !important`,
                            }}
                            />
                        </IconButton>
                        )}
                    </InputAdornment>
                    ),
                }}
            />
        </Box>
    )
}

export default SearchButton;